type CloneMetricSeries = {
  dates: Date[];
  passRate: number[];
  frequencyPerDay: number[];
  averageDurationMs: number[];
};

export const resolveSharedMetricSeriesMax = (
  metricSeriesById: Map<string, CloneMetricSeries> | undefined,
  selectValues: (metricSeries: CloneMetricSeries) => number[],
): number | undefined => {
  if (!metricSeriesById) return undefined;

  let maxValue: number | undefined;
  for (const metricSeries of metricSeriesById.values()) {
    for (const value of selectValues(metricSeries)) {
      if (!Number.isFinite(value)) continue;
      maxValue = maxValue === undefined ? value : Math.max(maxValue, value);
    }
  }

  return maxValue;
};

export type { CloneMetricSeries };
